// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4IfdD","content":"styles_content__3Rfez"};